import axios from "axios";
import React, { useState, useEffect } from "react";
import { Col, ListGroup, Row } from "react-bootstrap";

const AsyncSearchbar = ({ searchApi }) => {
  const [search, setSearch] = useState("");
  const [debounced, setDebounced] = useState("");

  const [results, setResults] = useState([]);

  // Update debounced value 500 ms after user stops typing
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounced(search);
    }, 500);

    return () => clearTimeout(handler);
  }, [search]);

  // Trigger search when debounced value changes
  useEffect(() => {
    const fetchData = async () => {
      if (!debounced) {
        setResults([]);
        return;
      }
      const response = await axios.get(searchApi + debounced);
      setResults(response.data);
    };

    fetchData();
  }, [debounced, searchApi]);

  const handleChange = (evt) => {
    setSearch(evt.target.value);
  };

  const preventEnterSubmit = (evt) => {
    if (evt.key === "Enter") {
      evt.preventDefault();
    }
  };

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="form-group">
          <div className="d-flex justify-content-start">
            <p>Buscador códigos CIE 10</p>
            <input
              type="text"
              className="form-control"
              onChange={handleChange}
              onKeyDown={preventEnterSubmit}
              value={search}
            />
          </div>
        </div>
      </form>
      <div className="overflow-auto" style={{ maxHeight: "300px" }}>
        <ListGroup>
          {results.map(({ level, code, description }) => (
            <ListGroup.Item key={code}>
              <Row>
                <Col xs={2}>{level}</Col>
                <Col xs={2}>{code}</Col>
                <Col xs={8}>{description}</Col>
              </Row>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    </>
  );
};

export default AsyncSearchbar;
